import { RecipeVariants } from '@theme/utils/createRecipeObj';
import { createUseRecipeHook } from '@theme/utils/createUseRecipeHook';
import { root } from './Txt.css';

export const useTxtStyle = createUseRecipeHook(root);
export type TxtStyleProps = RecipeVariants<typeof root>;
